export enum ConflictType {
    NUMBER_BILLING_MISS, NUMBER_PUBLIC_MISS, NUMBER_TYPE_MISSMATCH, NUMBER_PBX_MISSMATCH, NUMBER_PBX_MISS_IN_BILLING, NUMBER_PBX_MISS_IN_PUBLIC
}
